/**
 * @generated SignedSource<<ef85103184c89955c1398e4666c4c8a5>>
 * @relayHash b399d2046cff4012d0535ebe9e2e4b9c
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID b399d2046cff4012d0535ebe9e2e4b9c

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "offerType",
        "variableName": "offerType"
      }
    ],
    "concreteType": "References",
    "kind": "LinkedField",
    "name": "references",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberPassed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberFailed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TestQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TestQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "b399d2046cff4012d0535ebe9e2e4b9c",
    "metadata": {},
    "name": "TestQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "79ec98cda28d994012bbfba589358317";

export default node;
